import React from 'react';
import { MetricsElement } from "react-metrics";
import SpecialOffers from '../../product/components/special-offers';

import { Helpers } from '../../core/src/helpers';
import TextOverFlowToolTip from '../../shared/components/text-overflow-tooltip';

export default ({product, changeTab, message}) => {
		const maxOffers = 3;
    return (
        <MetricsElement
            element='div'
            data-metrics-event-name ='prodDetailsTab'
            data-metrics-event = 'e_prodDetailsTab'
            data-metrics-product-name = {product.name}
            data-metrics-details-tab-name = "Special Offers"
        >
            <span className="scroll-offers" onClick={changeTab}>
								<SpecialOffers 
								children={({offers})=>{
									let text = `${message ? message + ' ' : ''}${offers.map(offer => (offer.shortValue || offer.value).replace(/<\/?[^>]+(>|$)/g, "")).join(' | ')}`;  
									return <TextOverFlowToolTip className="offers-violator" markup={ Helpers.createMarkup(text) } clamp={ 2 } charMaxLength={ 180 }/>
								}}
								maxOffers={maxOffers} 
								product={product}
								/>
                {
                    product.offers.length > maxOffers && <span>See more offers</span>
                }
            </span>
        </MetricsElement>
    )
}